import Vue from 'vue'
import Router from 'vue-router'

//const Dashboard = () => import('@/views/Dashboard')
const Profile = () => import('@/components/Profile')
const Register = () => import('@/components/Register')
const Administrator = () => import('@/components/Administrator')
const UserDetails = () => import('@/components/UserDetails')

const RegisterDetails = () => import('@/components/RegisterDetails')
const EditRegisterDetails = () => import('@/components/EditRegisterDetails')

const Login = () => import('@/components/Login')
const Home = () => import('@/components/Home')


Vue.use(Router)

const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  base: process.env.BASE_URL,
  routes: configRoutes()
})

function configRoutes() {
  return [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/Profile/:number/:id',
      name: 'Profile',
      component: Profile
    },
    {
      path: '/Register',
      name: 'Register',
      component: Register
    },
    {
      path: '/RegisterDetails',
      name: 'RegisterDetails',
      component: RegisterDetails
    },
    {
      path: '/Administrator',
      name: 'Administrator',
      component: Administrator
    },
    {
      path: '/UserDetails',
      name: 'UserDetails',
      component: UserDetails
    },
    {
      path: '/EditRegisterDetails',
      name: 'EditRegisterDetails',
      component: EditRegisterDetails
    },
 
    
  ]
}
export default router

